


















import { JournalEntry } from "../../models/JournalEntry";
import { JournalApi } from "../../api/JournalApi";
import moment from "moment";

export default {
    name: "EntryValidationCheckbox",
    props: {
        value: JournalEntry,
        showAsButton: Boolean,
        showAsFolder: Boolean,
    },
    data() {
        return {
            JournalApi: new JournalApi(),
            entry: null,
        };
    },
    created() {
        this.entry = this.value;
    },
    computed: {
        isLate(): boolean {
            return !this.isClosed && this.entry.isLate;
        },
        isClosed(): boolean {
            return this.entry.status === JournalEntry.EStatus.Closed;
        },
        buttonClass(): string {
            if (this.showAsButton) {
                let res = "btn btn-sm ";
                if (this.isClosed) {
                    res += "btn-success";
                } else if (this.entry.isLate) {
                    res += "btn-danger";
                } else {
                    res += "btn-default";
                }
                return res;
            }
        },
    },
    methods: {
        toggleStatus(): void {
            let self = this;

            if (self.isClosed) {
                self.entry.status = JournalEntry.EStatus.Pending;
            } else {
                self.entry.status = JournalEntry.EStatus.Closed;
            }

            self.JournalApi.save(self.entry).then(function () {
                self.$emit("input", self.entry);
            });
        },
    },
};
